export default "<ng-template anwsersDirectiveHost></ng-template>\n";